import * as ActionTypes from '../actions/ActionTypes';
import TemplateEditorPublishStatus from '../records/TemplateEditorPublishStatus';
const INITIAL_STATE = new TemplateEditorPublishStatus();
export default function templateEditorPublishStatus(state = INITIAL_STATE, {
  error,
  payload,
  type
}) {
  switch (type) {
    case ActionTypes.FETCH_TEMPLATE_SETTINGS_SUCCESS:
      return state.merge({
        hasUnpublishedChanges: payload.hasUnpublishedChanges
      });
    case ActionTypes.UPDATE_TEMPLATE_SETTINGS_SUCCESS:
      return state.merge({
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'true' is not assignable to type 'undefined'.
        hasUnpublishedChanges: true
      });
    case ActionTypes.TEMPLATE_EDITOR_PUBLISH_PENDING:
      return state.merge({
        isUpdating: true,
        error: undefined
      });
    case ActionTypes.TEMPLATE_EDITOR_PUBLISH_SUCCESS:
      return state.merge({
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'false' is not assignable to type 'undefined'... Remove this comment to see the full error message
        hasUnpublishedChanges: false,
        isUpdating: false,
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'number' is not assignable to type 'null | un... Remove this comment to see the full error message
        lastUpdated: new Date().valueOf(),
        error: undefined
      });
    case ActionTypes.TEMPLATE_EDITOR_PUBLISH_ERROR:
      return state.merge({
        isUpdating: false,
        error
      });
    case ActionTypes.TEMPLATE_EDITOR_UPDATE_FORM_SUCCESS:
    case ActionTypes.VALIDATE_TEMPLATE_SETTINGS:
      return state.merge({
        // @ts-expect-error ts-migrate(2740) FIXME: Type 'Iterable<unknown, unknown>' is missing the f... Remove this comment to see the full error message
        validationErrors: state.validationErrors.merge(payload.errors).filter(err => !!err)
      });
    default:
      return state;
  }
}